import {hframe, vframe} from '@xh/hoist/cmp/layout';
import {creates, hoistCmp, uses} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {MoversWidgetModel} from './MoversWidgetModel';
import {grid} from '@xh/hoist/cmp/grid';
import {toolbarSep} from '@xh/hoist/desktop/cmp/toolbar';
import {widgetToolbar} from '../../../../cmp/widget/WidgetToolbar';
import {widgetToolbarSelect} from '../../../../cmp/widget/WidgetToolbarSelect';
import './MoversWidget.scss';
import {widgetToolbarCheckbox} from '../../../../cmp/widget/WidgetToolbarCheckbox';
import {widgetToolbarButton} from '../../../../cmp/widget/WidgetToolbarButton';
import {configurableGrid} from '../../../../cmp/gridSpec/ConfigurableGrid';

export const moversWidget = hoistCmp.factory<MoversWidgetModel>({
    model: creates(MoversWidgetModel),
    render({model}) {
        return panel({
            // One configurator for all four quadrants - the whole layout goes modal beside it.
            item: configurableGrid({model: model.configurableGridModel, item: vframe(topPanel(), bottomPanel())}),
            bbar: bbar()
        });
    }
});

// Quadrants render inside the configurable grid, so they name their model rather than take the nearest one
const topPanel = hoistCmp.factory<MoversWidgetModel>({
    model: uses(MoversWidgetModel),
    render: ({model}) =>
        hframe(
            panel({
                modelConfig: {
                    side: 'left',
                    defaultSize: '50%',
                    showSplitterCollapseButton: false,
                    resizable: false
                },
                item: grid({model: model.gridGainersLong, agOptions: model.agOptions})
            }),
            panel({item: grid({model: model.gridLosersLong, agOptions: model.agOptions})})
        )
});

const bottomPanel = hoistCmp.factory<MoversWidgetModel>({
    model: uses(MoversWidgetModel),
    render: ({model}) =>
        hframe({
            omit: !model.showShort,
            items: [
                panel({
                    modelConfig: {
                        side: 'left',
                        defaultSize: '50%',
                        showSplitterCollapseButton: false,
                        resizable: false
                    },
                    item: grid({model: model.gridGainersShort, agOptions: model.agOptions})
                }),
                panel({item: grid({model: model.gridLosersShort, agOptions: model.agOptions})})
            ]
        })
});

const bbar = hoistCmp.factory<MoversWidgetModel>(({model}) =>
    widgetToolbar({
        items: [
            widgetToolbarSelect({
                title: 'Count',
                options: [
                    {value: -1, label: 'Auto'},
                    {value: 5, label: 'top 5'},
                    {value: 10, label: 'top 10'},
                    {value: 25, label: 'top 15'},
                    {value: 50, label: 'top 20'}
                ],
                bind: 'count'
            }),
            toolbarSep(),
            widgetToolbarCheckbox({text: 'L/S', bind: 'showShort'}),
            toolbarSep(),
            widgetToolbarButton({
                text: 'by px %',
                active: model.sortColId === 'priceChangePct',
                onClick: () => model.setSort('priceChangePct')
            }),
            toolbarSep(),
            widgetToolbarButton({
                text: 'by p&l',
                active: model.sortColId === 'pnlDly',
                onClick: () => model.setSort('pnlDly')
            })
        ]
    })
);
